import { BodyOf } from "../../core/api";
import { createMutationGroup } from "../../core/api/mutations";
import { NursingQuestionId } from "../../shared/schema/schema";

export default createMutationGroup(({ api, createMutation }) => ({
  create: () =>
    createMutation({
      mutationFn: (body: BodyOf<"post", "./nursing_questions_settings">) =>
        api.post("./nursing_questions_settings", { body }),
    }),

  update: (nursingQuestionId: NursingQuestionId) =>
    createMutation({
      mutationFn: (body: BodyOf<"put", "./nursing_questions_settings/:nursingQuestionId">) =>
        api.put("./nursing_questions_settings/:nursingQuestionId", {
          path: { nursingQuestionId },
          body,
        }),
    }),

  remove: (nursingQuestionId: NursingQuestionId) =>
    createMutation({
      mutationFn: () =>
        api.delete("./nursing_questions_settings/:nursingQuestionId", {
          path: { nursingQuestionId },
        }),
    }),
}));
